// extracted by mini-css-extract-plugin
export var active = "_du-2";
export var recordingDot = "_du-1";
export var recordingIndicator = "_du-0";